import { useEffect, useState, useCallback } from 'react';
import UserService, { DEFAULT_USER } from '../services/UserService';
import useObservable from './UseObservable';
import { isTeacher } from 'lib/helpers';
import { USER_PARAMS } from '../lib/helpers';
import { KEYS_LOCALSTORAGE } from 'constants/general';
import { IUser } from 'interfaces';

const userService = UserService.getInstance();

function useAccount() {
  const [userData] = useObservable<IUser>(userService.getUser());
  const [user, setUser] = useState<IUser>(DEFAULT_USER);
  const authToken = localStorage.getItem('auth_token') || '';

  const fetchUser = useCallback(async (params: any) => {
    if (isTeacher()) {
      userService.fetchTeacher();
    }

    await userService.fetchUser(params);
  }, []);

  const updateUser = useCallback(async (dataUser: any) => {
    await userService.updateUser(dataUser);
  }, []);

  useEffect(() => {
    if (authToken) fetchUser(USER_PARAMS);
  }, [fetchUser, authToken]);

  useEffect(() => {
    if (userData) {
      const newData: any = {
        ...userData,
        id: userData.id?.toString() || localStorage.getItem(KEYS_LOCALSTORAGE.USER_ID) || '',
        email: userData.email || localStorage.getItem(KEYS_LOCALSTORAGE.USER_EMAIL) || '',
        type: userData.type || localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE) || '',
        fullname: `${userData.name || ''} ${userData.lastname || ''}`,
      };
      setUser({
        ...user || {},
        ...newData,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return {
    user,
    updateUser,
  };
}

export default useAccount;
